import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { subDomainQueries } from '@/services/premiumStores/subDomain/subDomain.queries';

export const useGetSubDomainDetail = (clubId: string) => {
  const { data, isLoading } = useQuery({
    ...subDomainQueries.detail({
      clubId,
    }),
    enabled: !!clubId,
  });
  return {
    data: data?.data,
    isLoading,
  };
};
